module.exports = "./img/eb6357bcbb6db4632cd5e7a8e656cb11.jpg";